import { render, staticRenderFns } from "./TipiContratto.vue?vue&type=template&id=2e832cfe&"
import script from "./TipiContratto.vue?vue&type=script&lang=ts&"
export * from "./TipiContratto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports